import React from 'react';
import { Card, CardContent, Typography, Button, Alert, Box } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useAssistant } from '../../contexts/AssistantContext';

export default function ConfirmationCard({ action }) {
  const { confirmAction, cancelAction } = useAssistant();

  if (!action) return null;

  const hasConflict = action.capacity_impact?.has_conflict;
  const conflictDetails = action.capacity_impact?.conflict_details;

  return (
    <Card variant="outlined" sx={{ mx: 0.5, borderColor: hasConflict ? 'warning.main' : 'divider' }}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        {/* Action summary */}
        <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
          {action.summary || action.description || 'Bevestig deze actie'}
        </Typography>

        {/* Details if present */}
        {action.details && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, fontSize: 13 }}>
            {action.details}
          </Typography>
        )}

        {/* Capacity conflict warning */}
        {hasConflict && (
          <Alert
            severity="warning"
            icon={<WarningAmberIcon fontSize="small" />}
            sx={{ mb: 1.5, py: 0.5, '& .MuiAlert-message': { fontSize: 13 } }}
          >
            {conflictDetails || 'Er is een capaciteitsconflict gevonden. Controleer de planning.'}
          </Alert>
        )}

        {/* Action buttons */}
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
          <Button
            size="small"
            variant="outlined"
            color="inherit"
            startIcon={<CloseIcon />}
            onClick={() => cancelAction(action.id || action.action_id)}
            sx={{ fontSize: 13, textTransform: 'none' }}
          >
            Annuleren
          </Button>
          <Button
            size="small"
            variant="contained"
            color="success"
            startIcon={<CheckIcon />}
            onClick={() => confirmAction(action.id || action.action_id)}
            sx={{ fontSize: 13, textTransform: 'none' }}
          >
            Bevestigen
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
